export enum ModalType {
  New = 'newWhitelabel',
  View = 'viewWhitelabel',
}
